/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useEffect, useState } from "react";
import VerifyOtpPage from "../components/Pages/VerifyOtpPage";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import Banner from "../components/Banner";
import LoginPage from "../components/Pages/LoginPage";
import ResetPage from "../components/Pages/ResetPage";
import SignupPage from "../components/Pages/SignupPage";
import SocialPage from "../components/Pages/SocialPage";
import ChangePassPage from "../components/Pages/ChangePassPage";
import { LoginService } from "../services/login.service";

const log: any = LoggerModule.getInstance();

interface BeautifulLoginProps {}
interface ShowBannerProps {
    message: string;
    show: boolean;
    type: "error" | "success";
}

// const loginService = LoginService.getInstance({
//     baseURL: "https://www.vlinder.io"
// });

const BeautifulLogin: React.FC<BeautifulLoginProps> = (props) => {
    const loginService = LoginService.getInstance({
        baseURL: props?.apiURL,
    });
    const [view, setView] = useState("login");
    const [activeEmail, setEmail] = useState();
    const [showBanner, setShowBanner] = useState<ShowBannerProps>({
        message: "",
        show: false,
        type: "success",
    });

    const mailSignin = async (data: { email: string; password: string }) => {
        const { email, password } = data;
        try {
            setShowBanner({
                message: "Loggin in, please wait",
                show: true,
                type: "success",
            });
            const result = await loginService.mailSignIn({
                email,
                password,
            });

            if (result && result?.data) {
                setShowBanner({
                    message: "Loggin Success!",
                    show: true,
                    type: "success",
                });
                props?.onLoginSuccess && props?.onLoginSuccess(result?.data);
            }
        } catch (error) {
            setShowBanner({
                message: error.message,
                show: true,
                type: "error",
            });
            props?.onLoginSuccess && props?.onLoginSuccess(error);
        }
        setTimeout(() => {
            setShowBanner({ message: "", show: false, type: "success" });
        }, 5000);
    };

    const mailSignUp = async (data: {
        givenName: string;
        familyName: string;
        email: string;
        password: string;
    }) => {
        const { email, password, givenName, familyName } = data;
        try {
            setShowBanner({
                message: "Signing up, Please wait...",
                show: true,
                type: "success",
            });
            const result = await loginService.mailSignUp({
                email,
                password,
                givenName,
                familyName,
            });

            if (result) {
                setEmail(email);
                log.blue("sign success", result);
                setView("verify");
            }
        } catch (error) {
            setShowBanner({
                message: error.message,
                show: true,
                type: "error",
            });
        }
        setTimeout(() => {
            setShowBanner({ message: "", show: false, type: "success" });
        }, 5000);
    };

    const socialSignin = async (provider: string) => {
        console.log(`social sign in button pressed`, provider);
        try {
            setShowBanner({
                message: "Signing request, Please wait...",
                show: true,
                type: "success",
            });
            await loginService.socialSignin({
                provider,
                baseURL: props?.apiURL,
            });
        } catch (error) {
            setShowBanner({
                message: error.message,
                show: true,
                type: "error",
            });
        }
        setTimeout(() => {
            setShowBanner({ message: "", show: false, type: "success" });
        }, 5000);
    };

    const resetPassword = async (data: { email: string }) => {
        const { email } = data;
        try {
            setShowBanner({
                message:
                    "Sending Email please check email for OTP , Please wait...",
                show: true,
                type: "success",
            });
            const result = await loginService.resetPassword({
                email,
                verifyAuthType: "otp",
            });
            if (result) {
                setEmail(email);
                log.blue("reset password", result);
                setView("change");
            }
        } catch (error) {
            setShowBanner({
                message: error.message,
                show: true,
                type: "error",
            });
        }
        setTimeout(() => {
            setShowBanner({ message: "", show: false, type: "success" });
        }, 5000);
    };

    const verifyOtp = async (data: { otp: string }) => {
        console.log(`otp number`, data?.otp);
        const { otp } = data;
        try {
            setShowBanner({
                message: "Verifying OTP, Please wait...",
                show: true,
                type: "success",
            });
            const result = await loginService.verifyEmail({
                email: activeEmail,
                otp,
            });
            if (result && result?.data) {
                setShowBanner({
                    message:
                        "Email Verification success, please login to proceed",
                    show: true,
                    type: "success",
                });
                setView("login");
            }
        } catch (error) {
            setShowBanner({
                message: error.message,
                show: true,
                type: "error",
            });
        }
        setTimeout(() => {
            setShowBanner({ message: "", show: false, type: "success" });
        }, 5000);
    };

    const onChangePass = async (data: { token: string; password: string }) => {
        log.blue(`change password`, data);
        const { token, password } = data;
        try {
            setShowBanner({
                message: "Changing Password, Please wait...",
                show: true,
                type: "success",
            });
            const result = await loginService.onChangePass({
                email: activeEmail,
                otp: token,
                password,
            });
            if (result && result?.data) {
                setShowBanner({
                    message: "Password changed successfully",
                    show: true,
                    type: "success",
                });
                setView("login");
            }
        } catch (error) {
            setShowBanner({
                message: error.message,
                show: true,
                type: "error",
            });
        }
        setTimeout(() => {
            setShowBanner({ message: "", show: false, type: "success" });
        }, 5000);
    };

    const selectedView = () => {
        switch (view) {
            case "login":
                return (
                    <LoginPage
                        {...props}
                        handleView={setView}
                        mailSignin={mailSignin}
                    />
                );
            case "signup":
                return (
                    <SignupPage
                        {...props}
                        handleView={setView}
                        mailSignUp={mailSignUp}
                    />
                );
            case "social":
                return (
                    <SocialPage
                        {...props}
                        handleView={setView}
                        socialSignin={socialSignin}
                    />
                );
            case "verify":
                return (
                    <VerifyOtpPage
                        {...props}
                        handleView={setView}
                        verifyOtp={verifyOtp}
                    />
                );
            case "change":
                return (
                    <ChangePassPage
                        {...props}
                        handleView={setView}
                        onChangePass={onChangePass}
                    />
                );

            default:
                return (
                    <ResetPage
                        handleView={setView}
                        resetPassword={resetPassword}
                    />
                );
        }
    };

    useEffect(() => {
        setShowBanner({ message: "", show: false, type: "success" });
    }, [view]);

    return (
        <div
            style={{
                width: "fit-content",
                height: "fit-content",
                position: "relative",
                display: "flex",
                justifyContent: "center",
            }}
        >
            {selectedView()}
        </div>
    );
};

export default BeautifulLogin;
